import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 🗑️ راهنمای ردیابی ضایعات

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای ثبت ضایعات تولید

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 فهرست مطالب و دسترسی سریع

1. [مقدمه و ساختار ضایعات](#sec-intro)
2. [ثبت ضایعات جدید](#sec-step1)
3. [مدیریت کدهای علت ضایعات](#sec-step2)

---

## 1. مقدمه و ساختار ضایعات

در پلتفرم میمزاد، سیستم **ردیابی ضایعات (Scrap Tracking)** به اپراتورها و سرپرستان تولید اجازه می‌دهد تا قطعات معیوب یا مواد دورریز را با دقت بالا ثبت و رهگیری کنند. 
این فرآیند به شناسایی گلوگاه‌های کیفی و محاسبهٔ نرخ بازدهی خط (Yield) کمک می‌کند. ضایعات به صورت مستقیم به یک سفارش کار (Work Order) مرتبط می‌شوند.

<Alert type="info">
  **دقت در ثبت:** شما می‌توانید ضایعات را به کل محصول نهایی در سفارش کار، یا به یک قطعهٔ خاص از درختواره (BOM) اختصاص دهید.
</Alert>

---

## 2. ثبت ضایعات جدید

برای ثبت یک مورد ضایعات جدید:

1. به تب **«ثبت ضایعات»** بروید.
2. از منوی کشویی، **سفارش کار** مربوطه را انتخاب کنید.
3. در صورت نیاز، قطعهٔ خاص (BOM Item) را انتخاب کنید. اگر قطعه‌ای را انتخاب نکنید، سیستم فرض می‌کند ضایعات مربوط به محصول نهایی آن سفارش است.
4. **کد علت** (دلیل خرابی) را وارد کنید.
5. **مقدار** ضایعات را ثبت کرده و روی **«ثبت ضایعات»** کلیک کنید.

---

## 3. مدیریت کدهای علت ضایعات

کدهای علت ضایعات (Scrap Reason Codes) برای استانداردسازی گزارش‌گیری از خرابی‌ها استفاده می‌شوند.

1. به تب **«کدهای علت ضایعات»** بروید.
2. برای تعریف کد جدید، **کد** (مثلاً `SCR-01`) و **توضیح** (مثلاً `شکستگی در قالب`) را وارد کرده و دکمهٔ **«افزودن»** را بزنید.
3. شما می‌توانید کدهای علت بلااستفاده را با دکمه‌های کناری، غیرفعال (Deactivate) کنید تا در فرم ثبت ضایعات نمایش داده نشوند.

<Alert type="tip">
  تحلیل دوره‌ای کدهای علت پرکاربرد، به دپارتمان کیفیت کمک می‌کند تا برنامه‌های پیشگیرانه‌ی مؤثرتری تدوین کند.
</Alert>
